/* ===== COSIMO GALLERY Collection JS ===== */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Filter panel toggle ─────────────────── */
  var filterToggle = document.querySelector('.ccp-filter-toggle');
  var filtersPanel = document.querySelector('.ccp-filters');
  var closeBtn     = document.querySelector('.ccp-filters-close');
  var overlay      = document.getElementById('ccp-filter-overlay');

  function isDesktop() { return window.innerWidth >= 1024; }

  function currentUrl() { return new URL(window.location.href); }

  function goTo(url) {
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }

  function openFilters() {
    if (!filtersPanel || isDesktop()) return;
    filtersPanel.classList.add('is-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  }

  function closeFilters() {
    if (!filtersPanel) return;
    filtersPanel.classList.remove('is-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  if (filterToggle) filterToggle.addEventListener('click', function () {
    filtersPanel.classList.contains('is-open') ? closeFilters() : openFilters();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeFilters);
  if (overlay)  overlay.addEventListener('click', closeFilters);

  /* ── Facet accordion ─────────────────────── */
  document.querySelectorAll('.ccp-facet-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('.ccp-facet-group');
      if (group) group.classList.toggle('is-open');
    });
  });

  /* Open first two groups (Price and Availability) by default */
  var openGroups = document.querySelectorAll('.ccp-facet-group');
  for (var g = 0; g < openGroups.length && g < 2; g++) {
    openGroups[g].classList.add('is-open');
  }

  /* ── Native facet filter auto-submit ────────── */
  var facetForm = document.getElementById('ccp-facet-form');
  if (facetForm) {
    facetForm.querySelectorAll('input[type="checkbox"]:not(.ccp-custom-filter-cb)').forEach(function (cb) {
      cb.addEventListener('change', function () { submitFacets(); });
    });
    facetForm.querySelectorAll('input[type="number"]').forEach(function (inp) {
      inp.addEventListener('change', function () { submitFacets(); });
    });
    facetForm.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFacets();
    });
  }

  /* Keeps the other filters (custom tags) and the sort order in the address */
  function submitFacets() {
    if (!facetForm) return;
    var url = currentUrl();
    var names = {};
    facetForm.querySelectorAll('input[name]').forEach(function (el) { names[el.name] = true; });
    Object.keys(names).forEach(function (n) { url.searchParams.delete(n); });
    var formData = new FormData(facetForm);
    for (var pair of formData.entries()) {
      if (pair[1]) url.searchParams.append(pair[0], pair[1]);
    }
    goTo(url);
  }

  /* ── Sort dropdown (keeps active filters) ───── */
  var sortSelect = document.getElementById('ccp-sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = currentUrl();
      url.searchParams.set('sort_by', this.value);
      goTo(url);
    });
  }

  /* ── Custom tag-based filters ────────────────
     These work by appending ?filter.p.tag=value to the URL
  ──────────────────────────────────────────── */
  document.querySelectorAll('.ccp-custom-filter-cb').forEach(function (cb) {
    cb.addEventListener('change', function () {
      var url = currentUrl();
      var tagParam = 'filter.p.tag';
      var allTags = url.searchParams.getAll(tagParam);

      if (this.checked) {
        if (!allTags.includes(this.value)) {
          url.searchParams.append(tagParam, this.value);
        }
      } else {
        url.searchParams.delete(tagParam);
        allTags.filter(function (t) { return t !== cb.value; })
          .forEach(function (t) { url.searchParams.append(tagParam, t); });
      }
      goTo(url);
    });

    /* Mark as checked if tag is in URL */
    var currentTags = new URLSearchParams(window.location.search).getAll('filter.p.tag');
    if (currentTags.includes(cb.value)) cb.checked = true;
  });

  /* ── Grid / List view toggle ─────────────── */
  var viewButtons = document.querySelectorAll('.ccp-view-btn');
  var grid        = document.querySelector('.ccp-product-grid');

  viewButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      viewButtons.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      if (!grid) return;
      var view = this.getAttribute('data-view');
      grid.setAttribute('data-grid-view', view);
      grid.style.gridTemplateColumns = view === 'list' ? '1fr' : '';
    });
  });

  /* ── Color swatch — image + URL swap ────────── */
  document.querySelectorAll('.ccp-card').forEach(function (card) {
    var mainImg    = card.querySelector('.ccp-card-img--primary');
    var secImg     = card.querySelector('.ccp-card-img--secondary');
    var titleLink  = card.querySelector('.ccp-card-title a');
    var mediaLink  = card.querySelector('.ccp-card-media');
    var priceEl    = card.querySelector('.ccp-price');
    var compareEl  = card.querySelector('.ccp-price--compare');
    var quickAdd   = card.querySelector('.ccp-card-quickadd');

    card.querySelectorAll('.ccp-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        /* Active state */
        card.querySelectorAll('.ccp-swatch').forEach(function (s) { s.classList.remove('active'); });
        this.classList.add('active');

        /* Swap image */
        var img = this.getAttribute('data-image');
        if (img && mainImg) mainImg.src = img;

        /* Swap secondary image */
        var img2 = this.getAttribute('data-image-2');
        if (secImg) secImg.src = img2 || img || '';

        /* Swap URL */
        var url = this.getAttribute('data-url');
        if (url) {
          if (titleLink) titleLink.href = url;
          if (mediaLink) mediaLink.href = url;
        }

        /* Swap price */
        var price = this.getAttribute('data-price');
        var compare = this.getAttribute('data-compare');
        if (price && priceEl) {
          priceEl.textContent = price;
          if (compare && compare !== '0' && compareEl) {
            compareEl.textContent = compare;
            compareEl.style.display = 'inline';
            priceEl.classList.add('ccp-price--sale');
          } else if (compareEl) {
            compareEl.style.display = 'none';
            priceEl.classList.remove('ccp-price--sale');
          }
        }

        /* Update quick add variant */
        var variantId = this.getAttribute('data-variant-id');
        if (variantId && quickAdd) {
          quickAdd.setAttribute('data-variant-id', variantId);
        }
      });
    });
  });

  /* ── Quick Add to Cart ───────────────────── */
  document.querySelectorAll('.ccp-card-quickadd').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = this.getAttribute('data-variant-id');
      if (!variantId) return;

      var self = this;
      self.disabled = true;
      var orig = self.textContent;
      self.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        self.textContent = '✓ Added';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        /* Update cart count in header */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count],[data-cart-item-count],.cart-count,.header__cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          });
        setTimeout(function () {
          self.textContent = orig;
          self.disabled = false;
        }, 1800);
      })
      .catch(function () {
        self.textContent = 'Error';
        setTimeout(function () {
          self.textContent = orig;
          self.disabled = false;
        }, 1800);
      });
    });
  });

});